'use strict';
// This file is auto generated by bin/createIconConstants.js
// Last updated: Mon Dec 17 2018 17:39:46 GMT-0500 (EST)

'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'align-center': 'alignCenter',
  'align-justify': 'alignJustify',
  'align-left': 'alignLeft',
  'align-right': 'alignRight',
  'angle-double-left': 'previous',
  'angle-double-right': 'next',
  'angle-left': 'left',
  'angle-right': 'right',
  'block-facebook': 'socialBlockFacebook',
  'block-google-plus': 'socialBlockGoogleplus',
  'block-linkedin': 'socialBlockLinkedin',
  'block-pinterest': 'socialBlockPinterest',
  'block-rss': 'socialBlockRss',
  'block-twitter': 'socialBlockTwitter',
  'block-xing': 'socialBlockXing',
  'block-youtube': 'socialBlockYoutube',
  'block-youtube-play': 'socialBlockYoutubeplay',
  'building-o': 'companies',
  calendar: 'date',
  call: 'calling',
  chain: 'link',
  check: 'success',
  check2: 'success',
  'clear-formatting': 'eraseStyles',
  clock: 'time',
  clock2: 'time',
  close: 'remove',
  'cloud-upload': 'upload',
  'comment-o': 'comments',
  'comments-o': 'comments',
  contact: 'contacts',
  contacts2: 'contacts',
  copy: 'duplicate',
  cross2: 'remove',
  'cta-click': 'ctas',
  deal: 'deals',
  dedent: 'outdent',
  document: 'documents',
  'down-angle': 'down',
  'down-arr': 'down',
  'email-open': 'emailOpen',
  embed2: 'code',
  eraser: 'eraseStyles',
  'external-link': 'externalLink',
  eye: 'view',
  'eye-slash': 'hide',
  facebook: 'socialFacebook',
  'file-text': 'file',
  'folder-open': 'folderOpen',
  form: 'forms',
  gear: 'settings',
  google: 'socialGoogle',
  'google-drive': 'socialGoogleDrive',
  'google-drive2': 'socialGoogleDrive',
  'google-plus': 'socialGoogleplus',
  'google-plus2': 'socialGoogleplus',
  hamburger: 'listView',
  handoffAgent: 'simpleBot',
  handshake: 'deals',
  'help-with-circle': 'info',
  layer: 'hubDB',
  'left-angle': 'left',
  'left-arr': 'left',
  'left-arrow': 'previous',
  linkedin: 'socialLinkedin',
  'list-ol': 'numberList',
  'list-ul': 'bulletList',
  lock: 'locked',
  mail: 'email',
  'mail-dark': 'email',
  microphone: 'record',
  newspaper: 'blog',
  pen: 'signature',
  pencil: 'edit',
  phone: 'calling',
  photo: 'insertImage',
  pinterest: 'socialPinterest',
  plus: 'add',
  'price-tag': 'tag',
  'quotes-left': 'insertQuote',
  'right-angle': 'right',
  'right-arr': 'right',
  'right-arrow': 'next',
  rss: 'socialRss',
  sourceCode: 'embed',
  star: 'favorite',
  'star-o': 'favorite',
  tickets: 'ticket',
  trash: 'delete',
  trash2: 'delete',
  twitter: 'socialTwitter',
  'up-angle': 'up',
  'up-arr': 'up',
  'upload-dark': 'upload',
  'upload-light': 'upload',
  user: 'contacts',
  'volume-down': 'volumeDown',
  'volume-off': 'volumeMute',
  'volume-up': 'volumeUp',
  'warning-triangle': 'warning',
  x: 'remove',
  xing: 'socialXing',
  youtube: 'socialYoutube',
  'youtube-play': 'socialYoutubeplay',
  'zoom-in': 'zoomIn',
  'zoom-out': 'zoomOut'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/icons/static-2.324/js/iconAliases.js
// module id = 940
// module chunks = 2 3